import React from 'react';
import arrowIcon from "../../assets/icons/arrow.png";
import PropTypes from 'prop-types';
import presentationBg from "../../assets/bg/presentation.webp"; // Assurez-vous que le chemin est correct

const ContentSection = ({
    title = "Présentation",
    content = "",
    buttonText = "En savoir plus",
    buttonLink = "#",
    showButton = true,
    primaryColor = "greenlogo",
    secondaryColor = "greenprimary",
    customClass = ""
}) => {
    // Classes dynamiques basées sur les couleurs
    const titleColorClass = `text-${primaryColor}`;
    const barColorClass = `bg-${primaryColor}`;
    const buttonColorClass = `bg-${secondaryColor} hover:bg-${secondaryColor}/90`;

    return (
        <div
            className={`w-full relative isolate ${customClass}`}
            style={{
                backgroundImage: `url(${presentationBg})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
            }}
        >
            {/* Overlay avec 80% d'opacité */}
            <div className="absolute inset-0 bg-white/80 -z-10"></div>

            <div className="relative px-4 py-6 md:py-8">
                {/* Conteneur principal  */}
                <div className="w-full max-w-7xl mx-auto px-2 md:px-4">
                    {/* Titre - centré sur mobile, aligné à gauche sur desktop */}
                    <h2 className={`flex items-center justify-center md:justify-start text-2xl sm:text-3xl lg:text-4xl font-semibold ${titleColorClass} mb-6`}>
                        <span className={`w-8 sm:w-10 lg:w-16 h-1.5 sm:h-2 lg:h-2.5 mt-2 ${barColorClass} mr-2`}></span>
                        {title}
                    </h2>

                    {/* Texte principal */}
                    <div className="max-w-7xl mx-auto md:mx-0">
                        {typeof content === 'string' ? (
                            <p className="text-gray-700 text-justify leading-relaxed sm:leading-loose mb-8">
                                {content}
                            </p>
                        ) : (
                            <div className="text-gray-700 text-justify leading-relaxed sm:leading-loose mb-8">
                                {content}
                            </div>
                        )}
                    </div>

                    {/* Bouton */}
                    {showButton && (
                        <div className="flex justify-center md:justify-start mb-8">
                            <a
                                href={buttonLink}
                                className={`${buttonColorClass} text-white font-bold w-full sm:w-auto px-3 sm:px-5 py-4 sm:py-4.5 flex items-center justify-center transition-all hover:bg-opacity-90`}
                            >
                                {buttonText}
                                <img src={arrowIcon} className="ml-3 h-4 w-auto" alt="Voir plus" />
                            </a>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

ContentSection.propTypes = {
    title: PropTypes.string,
    content: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    buttonText: PropTypes.string,
    buttonLink: PropTypes.string,
    showButton: PropTypes.bool,
    primaryColor: PropTypes.string,
    secondaryColor: PropTypes.string,
    customClass: PropTypes.string
};

export default ContentSection;
